/** What every Patriot tools field shows when it has no value. */
export const EMPTY = "—";

/**
 * An activation instant in the viewer's own zone, with seconds and the offset —
 * support compares these against Patriot's own screens and device logs, so the
 * offset has to be on the page rather than assumed.
 */
export function formatInstant(iso: string | undefined): string {
  if (iso === undefined || iso === "") return EMPTY;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleString("en-AU", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZoneName: "shortOffset",
  });
}

/**
 * Whether a Patriot text field has anything to show. The API keeps an empty
 * field as `""` rather than dropping it, so present is not the same as shown.
 */
export function hasText(text: string | undefined): text is string {
  return text !== undefined && text !== "";
}

/** A Patriot text field for display, or `EMPTY` when it has nothing to show. */
export function formatText(text: string | undefined): string {
  return hasText(text) ? text : EMPTY;
}
